import { render, staticRenderFns } from "./dictionariesList.vue?vue&type=template&id=6be4c119&scoped=true"
import script from "./dictionariesList.vue?vue&type=script&lang=js"
export * from "./dictionariesList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6be4c119",
  null
  
)

export default component.exports